import NavBar from "../Components/NavBar";
import ItemPanel from "../Components/ItemPanel";
import "../CSS/panel.css";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useState, useEffect } from "react";
const MySwal = withReactContent(Swal);

function Panel() {
  const navigate = useNavigate();

  //console.log("el dato local es" + localStorage.getItem("idLocal"));
  const [nombre, setNombre] = useState("");
  const elementos = [
    { nombre: "Eventos ", imagen: "eventos" },
 //   { nombre: "Parrillas", imagen: "zonaparrillas" },
    { nombre: "Mis Entradas", imagen: "misentradas" },
  //  { nombre: "Mis Reservas", imagen: "misreservas" },
  ];

  //cerrar panel
  const cerrar = () => {
    MySwal.fire({
      title: "Cerrar sesión?",
      text: "Desea cerrar sesión?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, Cerrar sesión",
    }).then((result) => {
      if (result.isConfirmed) {
        localStorage.setItem("idLocal", "");
        localStorage.setItem("nombreLocal", "");
        navigate("../login");
      }
    });
  };

  useEffect(() => {
    if (localStorage.getItem("idLocal") == "") {
      const idLocal = localStorage.getItem("idLocal");
      console.log("NO ES USER");
      navigate("../login");
    } else {
      setNombre(
        localStorage.getItem("nombreLocal") +
          " " +
          localStorage.getItem("apellidoLocal")
      );
    }
    const fechaActual = new Date();
    const año = fechaActual.getFullYear();
    const mes = String(fechaActual.getMonth() + 1).padStart(2, "0");
    const dia = String(fechaActual.getDate()).padStart(2, "0");
    const fechaFormateada = `${año}-${mes}-${dia}`;
    localStorage.setItem("fechaParrilla", fechaFormateada);
  }, []);
  return (
    <div className="panel">
      <NavBar
        titulo="BIENVENIDO"
        nombre={nombre}
        imagen="salir"
        logoTitulo="hola"
        cerrar={cerrar}
      ></NavBar>
      <div className="panel-descrip">
        <strong>PANEL DE CONTROL </strong>
      </div>

      <div className="panel-grid-container">
        {elementos.map((item) => (
          <div
            className="panel-element"
            onClick={() => navigate("./" + item.imagen)}
          >
            <ItemPanel nombre={item.nombre} imagen={item.imagen} />
          </div>
        ))}
      </div>
    </div>
  );
}

export default Panel;
